export const MARK_WORD = 'MARK_WORD'
export const READ_WORD = 'READ_WORD'
